// Generated by ReScript, PLEASE EDIT WITH CARE


function getRequirementList(param) {
  return {
          hd: /* Personal */0,
          tl: {
            hd: /* Business */1,
            tl: /* [] */0
          }
        };
}

function getRequirementLabel(frequency, labels) {
  switch (frequency) {
    case /* Personal */0 :
        return labels.personal;
    case /* Business */1 :
        return labels.business;
    case /* HouseShift */2 :
        return "";
    
  }
}

function isRequirementChecked(given_requirement, current_requirement) {
  if (given_requirement !== undefined) {
    return given_requirement === current_requirement;
  } else {
    return false;
  }
}

export {
  getRequirementList ,
  getRequirementLabel ,
  isRequirementChecked ,
}
/* No side effect */
